import hirerGraphqlClient from './client';
import gql from 'graphql-tag';

export const mutation = gql`
  mutation ExpireJob($input: ExpireJobInput!) {
    expireJob(input: $input) {
      jobId
    }
  }
`;

const expireJob = async (
  jobId: string,
  advertiserId: string,
  expiryTime?: string,
): Promise<void> => {
  await hirerGraphqlClient.mutate({
    variables: {
      input: {
        jobId,
        advertiserId,
        expiryTime,
      },
    },
    mutation,
  });
};

export default expireJob;
